import {
  getMinutesInHourAndMinutesStr,
  getStopServiceWindow,
} from "../../util";
import PickupDeliveryPopupRenderer from "./PickupDeliveryPopupRenderer";
import { getStopDetails } from "./utils";
import constants from "./constants";
const CompletedStopPopup = ({ task }) => {
  const { stopStatus, stopStatusClass } = getStopDetails(task.data);
  return (
    <PickupDeliveryPopupRenderer
      stopType={task?.data?.stopType}
      stopName={task?.data?.name}
      arrivalTime={task.arrivalTime}
      departureTime={task.departureTime}
      stopTime={getMinutesInHourAndMinutesStr(task.stopDuration)}
      statusLabel={constants.POPUP_LABELS.STATUS}
      statusValue={stopStatus}
      stopStatusClass={stopStatusClass}
      serviceWindow={getStopServiceWindow(task?.data)}
    />
  );
};

export default CompletedStopPopup;
